import { Component, OnInit } from '@angular/core';
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
import { appService } from "../../../app/_services/app.service";
import { ToastrService } from "ngx-toastr";
import { Helpers } from "../../helpers";
import { environment } from "../../../environments/environment";
const LNG_KEY = "SELECTED_LANGUAGE";
declare var $: any;

@Component({
    selector: 'app-FuelIssueIndent',
    templateUrl: './FuelIssueIndent.component.html',
})
export class FuelIssueIndentComponent implements OnInit {
    selectedLang: string;
    SelectedComapnyName: any;
    SelectedCompanyAdd: any;
    CompanyId: any;
    bookingId: any;
    consignmentDetailId: any;
    FuelIssueIndentData: any = [];
    hostURL = environment.apiUrl;

    constructor(
        private service: TranslateConfigService,
        private _appService: appService,
        private toastr: ToastrService,
        private translate: TranslateService) {
        let language = this.translate.getBrowserLang();
        let value = localStorage.getItem(LNG_KEY);
        if (value === "" || value === null || value === undefined) {
            this.translate.setDefaultLang(language);
            this.selectedLang = language;
        } else {
            this.service.setLanguage(value);
            this.selectedLang = value;
        }
        let val = localStorage.getItem(LNG_KEY);
    }

    ngOnInit() {
        this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
        this.SelectedComapnyName = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedComapnyName;
        this.SelectedCompanyAdd = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyAdd;
    }

    PrintFuelIssueIndent(BookingId) {
        this._appService.GetByTwoId("FuelPump", "FP_GetFuelIssueIndentPrintData", this.CompanyId, BookingId).subscribe((response) => {
            var expenseChargeDetail: any = [];
            this.FuelIssueIndentData = [];
            this.FuelIssueIndentData.push(...response.Table);
            expenseChargeDetail.push(...response.Table1);
            this.FuelIssueIndentData.forEach(element => {
                element.ExpenseChargeDetails = [];
                var countCharge = 1;
                var totalExpense = 0;
                expenseChargeDetail.forEach(elementEx => {
                    if (element.ExpenseId == elementEx.ExpenseId) {
                        element.ExpenseChargeDetails.push(elementEx);
                        countCharge = countCharge + 1;
                        totalExpense = totalExpense + elementEx.Amount;
                    }
                });
                element.ExpenseChargeDetailsLength = countCharge;
                element.TotalAmount = totalExpense;
            });
            setTimeout(() => {
                var divElements = document.getElementById("FuelIssueIndentModel");
                var $iframe = $("<iframe id='frame'>").appendTo("body");
                var printDiv =
                    "<html><head><title></title></head><body>" +
                    divElements.innerHTML +
                    "</body></html>";
                var win = $iframe[0].contentWindow || $iframe[0];
                $(win.document).ready(function () {
                    setTimeout(() => {
                        win.window.print();
                        setTimeout(() => {
                            $iframe.remove();
                        }, 500);
                    });
                });
                $iframe.contents().find("body").html(printDiv);
            }, 1000);
        },
            (err) => {
                this.toastr.error("Error occurred while fetching data !" + err, "error");
            });
    }

}
